import axios from "axios";
import { toast } from "react-toastify";
import { InferType, array, object, string } from "yup";
import { setCustomFields } from "./AdminSettingsSlice";
import { AppDispatch, RootState } from "../../../config/store";
import adminAxios from "../../../config/adminAxios";

export const updateCustomFieldRequestSchema = object({
  uuid: string().required().min(1),
  value: string()
    .test(
      "Allow empty string",
      "Title must be present",
      (title) => typeof title === "string" && title !== null
    )
    .defined(),
}).required();

type typeUpdateCustomFieldRequestSchema = InferType<
  typeof updateCustomFieldRequestSchema
>;

const updateCustomFieldResponseSchema = object({
  data: object({
    message: string().required(),
    customField: object({
      uuid: string().required(),
      value: string()
        .test(
          "Allow empty string",
          "Value must be present",
          (value) => typeof value === "string" && value !== null
        )
        .defined(),
      customKey: object({
        uuid: string().required(),
        name: string().required(),
      }),
    }).required(),
  }),
}).required();

type typeUpdateCustomFieldResponseSchema = InferType<
  typeof updateCustomFieldResponseSchema
>;
export const updateCustomField =
  (form: typeUpdateCustomFieldRequestSchema, silent?: boolean) =>
  (dispatch: AppDispatch, getState: () => RootState) =>
    adminAxios({ user: getState().admin.login.user })
      .put<
        typeUpdateCustomFieldRequestSchema,
        typeUpdateCustomFieldResponseSchema
      >(`custom-field/${form.uuid}`, form)
      .then(async (response) => {
        const validResponse = await updateCustomFieldResponseSchema.validate(
          response
        );
        if (silent !== true) toast.success("Successfully updated custom field");
        return validResponse;
      })
      .catch((error) => {
        toast.error(error.response?.data?.message ?? error.message);
      });

const organisationSchema = object({
  uuid: string().required(),
  logo: string().nullable(),
  createdAt: string().required(),
  name: string().required(),
  customFields: array(
    object({
      uuid: string().required(),
      value: string(),
      customKey: object({
        uuid: string().required(),
        name: string().required(),
      }).required(),
    }).required()
  ).required(),
}).required();

const getOrganisationResponseSchema = object({
  message: string().required(),
  organisation: organisationSchema,
}).required();

type typeGetOrganisationResponseSchema = InferType<
  typeof getOrganisationResponseSchema
>;
export type typeOrganisation =
  typeGetOrganisationResponseSchema["organisation"];

export type typeCustomFields =
  typeGetOrganisationResponseSchema["organisation"]["customFields"];

export const getOrganisation =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const response = await adminAxios({
        user: getState().admin.login.user,
      }).get<typeGetOrganisationResponseSchema>("organisation");
      await getOrganisationResponseSchema.validate(response.data);
      dispatch(setCustomFields(response.data.organisation.customFields));
    } catch (error: any) {
      toast.error(error.response?.data?.message ?? error.message);
      console.error(error);
      return null;
    }
  };
